import React from 'react';

class ScrollPager extends React.Component {
  
  constructor () {
    super ();
  }

  render () {
    return (
      <div className="scroll-pager">{this.props.children}</div>
    )
  }
}

export default ScrollPager;


// WEBPACK FOOTER //
// ./components/scroll-pager/index.js